import React from 'react';
import { View, ScrollView, Text, StyleSheet, TouchableOpacity, Platform, Dimensions } from 'react-native';
import CS from '../../constants/Styles';
import Colors from '../../constants/Colors';
import Images from '../../constants/Images';
import { acceptableIds } from '../../constants/Arrays';
import { Button, ULItem, PhotoId, BackgroundGradient, Loader, Alert } from '../../components';
import { FontAwesome5 } from '@expo/vector-icons';
import { Camera, CameraType } from 'expo-camera';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { useLinkTo } from '@react-navigation/native';
import * as ImagePicker from 'expo-image-picker';
import * as DocumentPicker from 'expo-document-picker';
import { manipulateImage, dataUrlToFile, isImageExtensionValid } from '../../utils/Functions';

const VerifyIdentity =({ ...props }) => {
  const [loading, setLoading] = React.useState(false);
  const [alertOptions, setAlertOptions] = React.useState({});
  const [photoIdPreview, setPhotoIdPreview] = React.useState(false);

  let photoIdRef = null;
  let scrollRef = React.useRef(null);
  const insets = useSafeAreaInsets();
  const linkTo = useLinkTo();

  React.useEffect(() => {
    checkSignUpProgress();
  }, []);

  const checkSignUpProgress = (route) => {
    if (!props.signUpProgress.PersonalProfile) {
      linkTo('/login');
    }
  }

  // const acceptableIds = [
  //   "Driver's license",
  //   "Passport",
  //   "Health card",
  //   "Permanent resident card",
  //   "Citizenship card",
  //   "Secure Certificate of Indian Status (SCIS)",
  //   "Nexus card",
  //   "Global entry card",
  //   "Provincial services card",
  //   "Provincial identity card",
  // ];

  const checkIdentity = () => {
    if(props.photoIds.length !== 2){
      setAlertOptions({ visible: true, title: 'Account Verification', message: `2 government-issued IDs are required to verify your identity. Please upload them before hitting "Continue".\n\nSelect "Do It Later" if you do not want, or are unable, to upload your IDs. However, please note that your account will remain unverified and you will face restrictions until your account is verified.\n\nYou may upload identification anytime by modifying your profile.` });
      return;
    }
    nextRoute();
  };
  const skipIdentity = () => {
    props.setPhotoIds([]);
    // confirm ???
    nextRoute();
  };
  const nextRoute = () => {
    props.completeStep('VerifyIdentity');
  }

  // photos
  // const addNewPhoto = () => {
  //   if(Platform.OS !== 'web'){
  //     previewPhotoId();
  //   }else{
  //     choosePhoto();
  //   }
  // }
  const addNewPhoto = () => {
    let alertButtons = [];
    if (Platform.OS !== 'web') {
      alertButtons = [
        {
          text: 'Take Photo',
          onPress: () => previewPhotoId(),
        },
        {
          text: 'Choose PDF Document',
          onPress: () => choosePDF(),
        }
      ];
    } else {
      alertButtons = [
        {
          text: 'Choose Photo',
          onPress: () => choosePhoto(),
        },
        {
          text: 'Choose PDF Document',
          onPress: () => choosePDF(),
        }
      ]
    }
    setAlertOptions({
      visible: true,
      title: 'Choose an option',
      message: 'Choose one of the following options.',
      buttons: alertButtons,
      dismissable: true,
    });
  }
  const choosePDF = async () => {
    const result = await DocumentPicker.getDocumentAsync({ type: 'application/pdf' });
    console.log('choosePDF()', result);
    if (result.type === 'success') {
      result.fileType = 'pdf';
      // props.setBusinessId(result);
      props.setPhotoIds(prevState => {
        const ids = [...prevState];
        ids.push(result);
        console.log('inside state change', ids);
        return ids;
      });
    }
  }
  const previewPhotoId = async () => {
    const permissionResult = await Camera.requestCameraPermissionsAsync();
    if (!permissionResult.granted) {
      setAlertOptions({ visible: true, title: 'Warning', message: 'Permission to access camera is required!', });
      return;
    }
    setPhotoIdPreview(true);
    setTimeout(() => {
      scrollRef.current.scrollToEnd({ animated: true });
    }, 100);
  }
  const takePhotoId = async () => {
    console.log('take photo id', photoIdRef);
    if (photoIdRef) {
      let result = await photoIdRef.takePictureAsync({
        quality: Images.quality,
        base64: false,
        exif: false,
      });
      if (!result.cancelled) {
        cancelPhotoIdPreview();
        const manipResult = await manipulateImage(result, Images.identification.width, Images.identification.height);
        console.log('manipResult: ', manipResult);
        if (!manipResult.cancelled) {
          manipResult.existing = false;
          manipResult.fileType = 'image';
          props.setPhotoIds(prevState => {
            const ids = [...prevState];
            ids.push(manipResult);
            console.log('inside state change', ids);
            return ids;
          });
          setTimeout(() => {
            scrollRef.current.scrollToEnd({ animated: true });
          }, 250);
        }
      }
    }
  }
  const cancelPhotoIdPreview = () => {
    setPhotoIdPreview(false);
  }
  // const choosePhoto = async () => {
  //   console.log('choosePhoto()');
  //   let permissionResult = await ImagePicker.requestMediaLibraryPermissionsAsync();
  //   if (permissionResult.granted === false) {
  //     setAlertOptions({ visible: true, title: 'Warning', message: 'Permission to access camera roll is required!', });
  //     return;
  //   }
  //   let result = await ImagePicker.launchImageLibraryAsync({
  //     mediaTypes: ImagePicker.MediaTypeOptions.Images,
  //     allowsEditing: true,
  //     // aspect: [1, 1],
  //     quality: 1,
  //   });
  //   // if (Platform.OS === 'web') {
  //   //   result.file = await dataUrlToFile(result.uri);
  //   // }

  //   if (!result.cancelled) {
  //     result.existing = false;
  //     // console.log('image Picker result: ', result);
  //     const manipResult = await manipulateImage(result, Images.identification.width, Images.identification.height, false);
  //     // const manipResult = await resizeImage(result, Images.identification.width, Images.identification.height);
  //     console.log('manipResult: ', manipResult);
  //     if (!manipResult.cancelled) {
  //       manipResult.existing = false;
  //       if (Platform.OS === 'web') {
  //         manipResult.file = await dataUrlToFile(manipResult.uri);
  //       }
  //       const isValidExtension = isImageExtensionValid(Platform.OS === 'web' ? manipResult.file.name : manipResult.uri);
  //       if (!isValidExtension.result) {
  //         setAlertOptions({ visible: true, title: 'Error', message: `Invalid image type. Images must end in one of the following extensions: ${isValidExtension.extensions}`, });
  //         return;
  //       }
  //       // props.setBusinessId(manipResult);
  //       props.setPhotoIds(prevState => {
  //         const ids = [...prevState];
  //         ids.push(manipResult);
  //         console.log('inside state change', ids);
  //         return ids;
  //       });
  //       setTimeout(() => {
  //         scrollRef.current.scrollToEnd({ animated: true });
  //       }, 250);
  //     }
  //   }
  // };
  const choosePhoto = async () => {
    console.log('choosePhoto()');
    let permissionResult = await ImagePicker.requestMediaLibraryPermissionsAsync();
    if (permissionResult.granted === false) {
      setAlertOptions({ visible: true, title: 'Warning', message: 'Permission to access camera roll is required!', });
      return;
    }
    let result = await ImagePicker.launchImageLibraryAsync({
      mediaTypes: ImagePicker.MediaTypeOptions.Images,
      allowsEditing: true,
      // aspect: [1, 1],
      quality: 1,
    });

    if (!result.canceled) {
      result.assets[0].existing = false;
      result.assets[0].fileType = 'image';
      if (Platform.OS === 'web') {
        result.assets[0].file = await dataUrlToFile(result.assets[0].uri);
      }
      console.log('result: ', result);
      const isValidExtension = isImageExtensionValid(Platform.OS === 'web' ? result.assets[0].file.name : result.assets[0].uri);
      if (!isValidExtension.result) {
        setAlertOptions({ visible: true, title: 'Error', message: `Invalid image type. Images must end in one of the following extensions: ${isValidExtension.extensions}`, });
        return;
      }
      props.setPhotoIds(prevState => {
        const ids = [...prevState];
        ids.push(result.assets[0]);
        console.log('inside state change', ids);
        return ids;
      });
      setTimeout(() => {
        scrollRef.current.scrollToEnd({ animated: true });
      }, 250);
    }
  };

  const goBack = () => {
    if (props.navigation.canGoBack()) {
      props.navigation.goBack();
    } else {
      linkTo('/signup/personalprofile');
    }
  }

  return (
    <View style={CS.container}>
      <BackgroundGradient />
      <Loader animating={loading} />
      <Alert options={alertOptions} setOptions={setAlertOptions} />
      <ScrollView ref={scrollRef} contentContainerStyle={[styles.innerContainer, { paddingTop: insets.top, paddingBottom: insets.bottom }]} style={styles.container}>
        <TouchableOpacity onPress={goBack} style={{ marginTop: 10, marginBottom: 20, justifyContent: 'center' }}>
          <FontAwesome5 name="arrow-left" size={24} color="white" style={{ position: 'absolute' }} />
          <Text style={[CS.mediumTitle, CS.lightText, CS.centerText, { marginVertical: 0 }]}>Verify Identity</Text>
        </TouchableOpacity>
        <Text style={[CS.smallText, CS.lightBlueText, { marginBottom: 10 }]}>You must be personally verified in order to send or receive money. You can setup a project without being verified, however no money can be exchanged.</Text>
        <Text style={[CS.smallText, CS.lightBlueText]}>Your identification is only used by Renovation Trust personnel for the purposes of verifying your identity and is never sold. It is also not shared with contractors or homeowners.</Text>
        <Text style={[CS.smallTitle, CS.lightText]}>Photos of government-issued ID</Text>
        <Text style={[CS.smallText, CS.lightBlueText]}>2 government-issued IDs are required to become verified</Text>
        <Text style={[CS.smallText, CS.lightBlueText, { marginBottom: 10 }]}>Supported file formats include: jpg, png, tif, gif, webp</Text>
        <Text style={[CS.smallText, CS.lightBlueText]}>Acceptable IDs:</Text>
        <View style={styles.acceptableIdsList}>
          {acceptableIds.map((v, index) => { return (<ULItem text={v} key={index} textColor='lightBlue' />); })}
          {/* {props.photoIds.length !== 2 &&
            <Text style={[CS.miniText, CS.redText]}>* 2 government issued ID's are required for proper verification</Text>
          } */}
        </View>
        {/* ids */}
        <View style={styles.ids}>
          {props.photoIds.map((id, index) => { return (<PhotoId uri={id.uri} fileType={id.fileType} fileName={id.name || ''} key={index} remove={props.removePhotoId} width={id.width} height={id.height} />); })}
          {photoIdPreview && 
          <View style={styles.photoIdPreviewContainer}>
            <Camera style={styles.photoIdPreview} type={CameraType.back} ref={ref => photoIdRef = ref}>
              <Text style={styles.takePhotoIdText}>Take a photo of your ID</Text>
            </Camera>
            <View style={CS.rowContainer}>
              <View style={CS.buttonLeft}>
                <Button text='Cancel' onPress={() => cancelPhotoIdPreview} color='blue' />
              </View>
              <View style={CS.buttonRight}>
                <Button text='Take Photo' onPress={() => takePhotoId} />
              </View>
            </View>
          </View>
          }
          {(!photoIdPreview && props.photoIds.length < 2) && (
          <TouchableOpacity style={styles.addNewId} onPress={addNewPhoto}>
            <FontAwesome5 name="address-card" size={80} color={Colors.lightBlue} />
            <Text style={[CS.boldText, styles.addNewText]}>Add New</Text>
          </TouchableOpacity>
          )}
        </View>

        <Text style={[CS.smallText, CS.lightBlueText, { marginBottom: 10 }]}>If you have concerns, difficulty or would like to provide alternate forms of identification, please reach out to us.</Text>

        {!photoIdPreview && (
          <View style={[CS.rowContainer, CS.buttons, { marginTop: 'auto' }]}>
            <View style={CS.buttonLeft}>
              <Button text='Do it Later' onPress={() => skipIdentity} color='blue' />
            </View>
            <View style={CS.buttonRight}>
              <Button text='Continue' onPress={() => checkIdentity} />
            </View>
          </View>
        )}
        
      </ScrollView>
    </View>
  )
}

const styles = StyleSheet.create({
  container: {
    width: '100%',
    flex: 1,
    marginVertical: 10,
    paddingHorizontal: 10,
  },
  innerContainer: {
    width: '100%',
    // backgroundColor: 'blue',
    maxWidth: Platform.OS === 'web' ? 768 : '100%',
    // justifyContent: Platform.OS === 'web' ? 'center' : 'flex-start',
    flexGrow: 1,
    alignSelf: 'center',
  },
  // signUp: {
  //   // width: '100%',
  //   // marginTop: 'auto',
  //   // marginBottom: 'auto',
  //   marginVertical:10,
  // },
  acceptableIdsList: {
    marginTop: 10,
    marginBottom: 20,
  },
  ids: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    // marginBottom:20,
  },
  addNewId: {
    // alignItems: 'center',
    // justifyContent: 'center',
    // borderRadius: 10,
    // borderStyle: 'dashed',
    // borderWidth: 2,
    // borderColor: Colors.lightBlue,
    // width: '46%',
    // padding: 10,
    // marginHorizontal: '2%',
    // marginBottom: '4%',

    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 10,
    borderStyle: 'dashed',
    borderWidth: 2,
    borderColor: Colors.lightBlue,
    width: '100%',
    padding: 10,
    marginBottom: '4%',
  },
  addNewText: {
    color: Colors.lightBlue,
    fontSize: 24,
  },
  photoIdPreviewContainer: {
    width: '100%',
    // height: 240,
    height: Dimensions.get('window').width - 20,
    marginBottom: 10,
  },
  photoIdPreview: {
    flex: 1,
    borderRadius: 10,
    justifyContent: 'center',
    marginBottom: 10,
    width: '100%',
    // aspectRatio: 1,
  },
  takePhotoIdText: {
    padding: 20,
    width: '100%',
    backgroundColor: Colors.transparentGrey,
    textAlign: 'center',
    fontSize: 24,
  },
});

export default React.memo(VerifyIdentity);